import React from "react";

export default function Logo({ className = "", style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="100 345 610 110"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="grad-gray-1" x1="106.33" y1="419.28" x2="190.2" y2="419.28" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#fafafa" />
          <stop offset="0.1" stopColor="#ececec" />
          <stop offset="0.53" stopColor="#b5b4b4" />
          <stop offset="0.85" stopColor="#8a8888" />
          <stop offset="1" stopColor="#7a7878" />
        </linearGradient>
        <linearGradient id="grad-purple-1" x1="1806.28" y1="740.71" x2="1745.82" y2="680.25" gradientTransform="translate(1959.5 1093.68) rotate(-180)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#f5f5f5" />
          <stop offset="0.18" stopColor="#d5cfe5" />
          <stop offset="0.39" stopColor="#b0a3cc" />
          <stop offset="0.57" stopColor="#9380b8" />
          <stop offset="0.72" stopColor="#826eac" />
          <stop offset="0.81" stopColor="#7b63a8" />
        </linearGradient>
        <linearGradient id="grad-purple-2" x1="1821.16" y1="702.75" x2="1802.9" y2="734.37" gradientTransform="translate(1959.5 1093.68) rotate(-180)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#f5f5f5" />
          <stop offset="0.18" stopColor="#d5cfe5" />
          <stop offset="0.39" stopColor="#b0a3cc" />
          <stop offset="0.57" stopColor="#9380b8" />
          <stop offset="0.72" stopColor="#826eac" />
          <stop offset="0.81" stopColor="#7b63a8" />
        </linearGradient>
        <linearGradient id="grad-gray-2" x1="186.9" y1="399.98" x2="166.45" y2="435.4" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#fafafa" />
          <stop offset="0.1" stopColor="#ececec" />
          <stop offset="0.53" stopColor="#b5b4b4" />
          <stop offset="0.85" stopColor="#8a8888" />
          <stop offset="1" stopColor="#7a7878" />
        </linearGradient>
      </defs>

      {/* Text: LIBERTY SOFT */}
      <g fill="#9a80c8">
        <path d="M270.55,420.71h20.44v-9.65h-19.92c-6.62,0-9.83-2.68-9.83-8.19v-33.24h-9.64v33.31c0,11.46,6.73,17.77,18.96,17.77Z" />
        <rect x="297.19" y="365.76" width="8.83" height="10.02" />
        <rect x="297.19" y="380.56" width="8.75" height="40.14" />
        <path d="M341.37,380.56h-16.97v-17.04h-8.75v39.94c0,11.44,5,17.24,14.87,17.24h10.86c11.22,0,17.39-7.13,17.39-20.07s-6.18-20.07-17.39-20.07ZM324.39,389.02h16.15c6.67,0,9.39,3.37,9.39,11.62s-2.72,11.54-9.39,11.54h-7.74c-6.06,0-8.42-2.55-8.42-9.09v-14.07Z" />
        <path d="M379.9,420.71h24.46v-8.53h-24.46c-3.66,0-5.59-1.73-5.59-5v-2.39h18.24c9.38,0,13.75-3.73,13.75-11.74s-4.6-12.48-13.68-12.48h-12.72c-9.11,0-14.12,4.75-14.12,13.38v13.39c0,8.63,5.02,13.38,14.12,13.38ZM379.9,389.02h12.65c3.37,0,5.15,1.55,5.15,4.48,0,1.83-.56,4.25-5.37,4.25h-18.01v-3.73c0-3.22,1.99-5,5.59-5Z" />
        <path d="M423.04,393.64c0-3.2,1.43-4.63,4.63-4.63h14.27v-8.45h-16.58c-7.76,0-11.07,3.55-11.07,11.89v28.26h8.75v-27.06Z" />
        <path d="M459.79,371.26h-8.83v9.3h-5.36v8.45h5.36v17.72c0,10.05,3.37,13.97,12.04,13.97h7.5v-8.08h-5.86c-3.58,0-4.85-1.42-4.85-5.44v-18.16h10.86v-8.45h-10.86v-9.3Z" />
        <path d="M492.77,419.28l-7.37,17.19h9.43l23.77-55.31.26-.61h-9.35l-13.31,30.87h-.76c-1.34,0-1.52-.13-1.98-1.37l-11.83-29.23-.11-.27h-9.26l13.4,33.62c1.27,3.23,2.75,4.95,7.11,5.1Z" />
        <path d="M569.75,390.31h-11.75c-4.65,0-7.01-1.86-7.01-5.52s2.17-5.52,6.11-5.52h26.17v-9.65h-25.88c-10.35,0-16.06,5.28-16.06,14.86,0,6.81,2.94,14.94,16.95,14.94h11.68c4.94,0,7.45,1.96,7.45,5.82s-2.3,5.81-6.48,5.81h-28.7v9.65h28.4c10.59,0,16.43-5.38,16.43-15.16,0-6.95-3.01-15.24-17.32-15.24Z" />
        <path d="M636.09,400.63c0-12.94-6.2-20.07-17.47-20.07h-8.26c-11.27,0-17.47,7.13-17.47,20.07s6.2,20.07,17.47,20.07h8.26c11.27,0,17.47-7.13,17.47-20.07ZM627.27,400.63c0,8.09-2.81,11.54-9.38,11.54h-6.77c-6.67,0-9.39-3.34-9.39-11.54s2.72-11.62,9.39-11.62h6.77c6.58,0,9.38,3.47,9.38,11.62Z" />
        <path d="M645.35,420.71h8.82v-31.69h10.86v-8.45h-10.86v-3.51c0-4.02,1.27-5.44,4.85-5.44h5.87v-8.08h-7.5c-8.66,0-12.04,3.92-12.04,13.97v3.06h-5.36v8.45h5.36v31.69Z" />
        <path d="M673.99,406.73c0,10.05,3.38,13.97,12.04,13.97h7.5v-8.08h-5.87c-3.58,0-4.85-1.42-4.85-5.44v-18.16h10.86v-8.45h-10.86v-9.3h-8.82v9.3h-5.36v8.45h5.36v17.72Z" />
      </g>

      {/* Graphic mark */}
      <g>
        <path fill="url(#grad-purple-2)" d="M163.5,432.2h0l-32.33-32.33h0s-12.42-12.43-12.42-12.43l-12.43,12.43,44.75,44.75c4.33,4.33,10.02,6.5,15.71,6.5s11.38-2.17,15.71-6.5l7.7-7.7c-8.78,7.1-18.5,3.41-26.7-4.72Z" />
        <path fill="url(#grad-purple-1)" d="M169.81,367.8h0l32.33,32.33h0s12.42,12.43,12.42,12.43l12.43-12.43-44.75-44.75c-4.33-4.33-10.02-6.5-15.71-6.5s-11.38,2.17-15.71,6.5l-10.89,10.89c8.78-7.1,21.69-6.6,29.89,1.53Z" />
        <path fill="url(#grad-gray-1)" d="M139.46,391.57l23.77-23.77c1.81-1.81,4.77-1.81,6.58,0h0c-8.2-8.13-21.1-8.63-29.89-1.53l-12.89,12.89,12.42,12.42Z" />
        <path fill="url(#grad-gray-2)" d="M203.08,424.03h0s-11.4-11.4-11.4-11.4l-1.02-1.02h0l-22.38-22.38-12.42,12.42,9.95,9.95h-.01s12.42,12.44,12.42,12.44l-8.15,8.15c-1.81,1.81-4.77,1.81-6.58,0h0c8.2,8.13,17.91,11.82,26.7,4.72l.45-.45h0l12.44-12.44h0Z" />
      </g>
    </svg>
  );
}